var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22 5.995A.995.995 0 0021.005 5h-8.01a.995.995 0 100 1.99h8.01A.995.995 0 0022 5.995zM22 12a.995.995 0 00-.995-.995H2.995a.995.995 0 100 1.99h18.01A.995.995 0 0022 12zm-.995 5.01a.995.995 0 110 1.99H8.995a.995.995 0 110-1.99h12.01z"}));
}

Menu.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Menu;

Menu.default = Menu;
